import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  width: min(420px, calc(100vw - 32px));
  max-height: 80vh;
  overflow: hidden;

  // The picker renders inside the auth forms, whose 'form header' rules (centred column, big logo
  // image) would otherwise win; the doubled class outranks them and the resets undo what they add
  && header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 0;
    padding: 20px 20px 12px;
    text-align: left;

    h3 {
      margin: 0;
      font-size: 20px;
      font-weight: bold;
      color: ${ ({ theme }) => theme.colors.black };
    }

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      padding: 0;
      border: none;
      border-radius: 50%;
      background: transparent;
      cursor: pointer;

      &:hover {
        background: ${ ({ theme }) => theme.colors.almostWhite };
      }

      img {
        display: block;
        width: 16px;
        height: 16px;
        padding: 0;
        border-radius: 0;
        background: transparent;
        box-shadow: none;
      }
    }
  }

  .search {
    position: relative;
    margin: 0 20px 12px;

    img {
      position: absolute;
      top: 50%;
      left: 12px;
      width: 18px;
      height: 18px;
      transform: translateY(-50%);
      filter: brightness(0);
      opacity: 0.5;
      pointer-events: none;
    }

    input {
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      padding: 0 12px 0 40px;
      border: 1px solid ${ ({ theme }) => theme.colors.grey };
      border-radius: 8px;
      font-family: inherit;
      font-size: 16px;
      color: ${ ({ theme }) => theme.colors.black };
      outline: none;

      &:focus {
        border-color: ${ ({ theme }) => theme.colors.primary };
      }
    }
  }

  .countries {
    flex: 1;
    margin: 0;
    padding: 0 8px 12px;
    overflow-y: auto;
    list-style: none;

    button {
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      min-height: 48px;
      padding: 0 12px;
      border: none;
      border-radius: 8px;
      background: transparent;
      font-family: inherit;
      font-size: 16px;
      text-align: left;
      color: ${ ({ theme }) => theme.colors.black };
      cursor: pointer;

      &:hover,
      &:focus-visible {
        background: ${ ({ theme }) => theme.colors.almostWhite };
        outline: none;
      }

      &.selected {
        background: ${ ({ theme }) => theme.colors.accentLight };
        font-weight: 600;

        .dial-code {
          color: ${ ({ theme }) => theme.colors.accent };
        }
      }
    }

    .flag {
      font-size: 22px;
      line-height: 1;
    }

    .name {
      flex: 1;
    }

    .dial-code {
      color: ${ ({ theme }) => theme.colors.greyMedium };
      font-variant-numeric: tabular-nums;
    }

    .empty {
      padding: 24px 12px;
      text-align: center;
      color: ${ ({ theme }) => theme.colors.greyMedium };
    }
  }
`
